<template>
    <ul uk-accordion active="0" multiple="true">
        <li v-for="item in items" class="faq uk-width-1-1" data-uk-rr-grid-item>
            <a class="faq__title uk-accordion-title">{{item.question}}</a>
            <div class="faq__content uk-accordion-content">
                <p>{{item.answer}}</p>
            </div>
        </li>
    </ul>
</template>
<script>
  import DataGridResults from 'js/theme-mixins/DataGridResults';

  export default {
    mixins: [DataGridResults],
  }
</script>



// WEBPACK FOOTER //
// public/themes/frontend/uikit3/extensions/rubinred/collections/assets/js/components/FAQDataGridResults.vue